export class TwInspeccionUiCamViewModel {
    public Id?: number;
    public IdUnidadInspeccionCam: number;
    public IdPeriodoInspeccionCam: number;
    public IdUsuario: number;
    public Inspector: string;
    public FechaInspeccion: Date;
    public IdResultadoInspeccionCam?: number;
    public FechaCaducidad?: Date;
    public Observaciones: string;
    public IdUsuarioModificacion?: number;
    public FechaModificacion?: Date;
    public IdUsuarioBorrado?: number;
    public FechaBorrado?: Date;
}

export class TwInspeccionCamViewModel extends TwInspeccionUiCamViewModel {
    public CodigoUhc: string;
    public DescripcionEstadoUi: string;
    public DescripcionCampania: string;
    public DescripcionPeriodo: string;
    public DescripcionCa: string;
    public DescripcionEa: string;
    public DescripcionOperador: string;
    public DescripcionPeriodoInspeccion: string;
    public DescripcionTipoInspeccion: string;
    public DescripcionResultadoInspeccion: string;
}

export class InspeccionUIPeriodo {
    public nombre = '';
    public tipoInspeccion = '';
    public configuradas = 0;
    public cumplimentadas = 0;
}

export class ResultadoInspeccionSelected {
    public idResultado: number;
    public idPeriodoInspeccionCam: number;
}

export enum EnumTcTipoInspeccionCam {
    ID_PRIMERA_INSPECCION = 1,
    ID_INSPECCION_SEGUIMIENTO = 2,
    ID_INSPECCION_FINAL = 3,
}

export enum EnumTwTcResultadoInspeccionCam {
    ID_ACEPTADA = 1,
    ID_RECHAZADA = 2,
}
